module.exports = __webpack_public_path__ + "static/media/FFC2D77F-AF9E-4EC8-A2C7-58138EB19223.bcf872ea.JPG";